// extracted by mini-css-extract-plugin
export var parkingListHeader = "search-result-paging-row-module--parkingListHeader--2E51V";
export var displayingItemsCountText = "search-result-paging-row-module--displayingItemsCountText--Miioj";
export var pageLinkRow = "search-result-paging-row-module--pageLinkRow--SGaFb";
export var pageLinkText = "search-result-paging-row-module--pageLinkText--stOha";
export var disabledPageLinkText = "search-result-paging-row-module--disabledPageLinkText--IWpgx";
export var sortMenuButton = "search-result-paging-row-module--sortMenuButton--2Jjuy";